import { Locales } from '~types/Locales.types';

const SUPPORTED_LOCALES: string[] = Object.values(Locales);

function isSupportedLocale(locale: string): boolean {
  return SUPPORTED_LOCALES.includes(locale);
}

export function stripLocale(pathname: string) {
  const normalized = pathname.replace(/^\/+/, '');

  if (!normalized) return '/';

  const parts = normalized.split('/').filter(Boolean);

  if (parts.length === 0) return '/';

  const firstSegment = parts[0];

  if (isSupportedLocale(firstSegment)) {
    const remainingSegments = parts.slice(1);

    if (remainingSegments.length === 0) {
      return '/';
    }

    const newPath = `/${remainingSegments.join('/')}`;

    return `${newPath}/`;
  }

  return pathname;
}
